import * as React from "react";
import { Provider } from "react-redux";
import Router from "../router/Router";
import withRoot from "../theme";

//  Apply MUI theme to app context
const WithTheme = withRoot(Router);

type ProdRootProps = {
  store: any;
};

const Root: React.FunctionComponent<ProdRootProps> = ({ store }) => (
  <Provider store={store}>
    <WithTheme />
  </Provider>
);

export default Root;
